import axios from "axios"

const bankinfo = {
    namespaced: true,
    state: {},
    mutations: {},
    actions: {
        async getBankInfo(context, payload) {
            let response = await axios.get(`/bank_info/${payload}`);
            if (response.status === 200) {
                return response;
            } else if (response.data.error) {
                throw new Error("Something is wrong");
            }
        },
        async getDebtors(){
            let response = await axios.get(`/debtor_list`);
            if (response.status === 200) {
                return response;
            } else if (response.data.error) {
                throw new Error("Something is wrong");
            }
        }
    },
    getters: {}
}

export default bankinfo;